import { useRef } from "react";
import { CloseIcon, EnterArrowIcon, SearchIcon } from "../../Assets/assets";
import "./SearchBox.css";
export default function SearchBox(props) {
  const searchBoxRef = useRef(null);

  return (
    <div
      className="inherit-parent-height inherit-parent-width"
      ref={searchBoxRef}
    >
      <form
        onSubmit={(event) => {
          event.preventDefault();
          if (!props.loading && props.showCloseIcon) {
            props.closeOnClick();
          } else if (!props.loading && props.showEnterIcon) {
            props.enterOnClick();
          }
        }}
        className={`inherit-parent-width`}
      >
        <div
          data-cy="search-box"
          style={{
            backgroundColor: "var(--tertiaryColor8)"
          }}
          className="display-flex flex-justify-content-center padding-default flex-align-items-center"
        >
          <div className="inherit-parent-height display-flex flex-align-items-center flex-justify-content-center padding-left-default ">
            <SearchIcon
              color="var(--tertiaryColor6)"
              width="13px"
              height="13px"
            />
          </div>
          <input
            style={{
              backgroundColor: "var(--tertiaryColor8)"
            }}
            className="font-color-tertiaryColor inherit-parent-height border-none font-size-medium padding-left-default inherit-parent-width"
            value={props.value}
            onChange={props.onChange}
            placeholder={props.placeHolder}
            title="Search bar"
            data-cy="search-input-field"
          />
          <button
            className="padding-right-default background-color-transparent cursor-pointer display-flex flex-justify-content-center"
            type="submit"
            data-cy={
              props?.activeSwitch === "TABLE"
                ? "search-clear-button"
                : "search-button"
            }
          >
            {props.showCloseIcon ? (
              <CloseIcon color="var(--tertiaryColor6)" width={16} height={16} />
            ) : (
              <></>
            )}
            {props.showEnterIcon ? (
              <EnterArrowIcon
                color="var(--tertiaryColor6)"
                width={16}
                height={16}
              />
            ) : (
              <></>
            )}
            {props.loading ? (
              <div
                className="export-loader"
                style={{ height: "16px", width: "16px" }}
              />
            ) : (
              <></>
            )}
          </button>
        </div>
      </form>
    </div>
  );
}
